import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkAll", "item"]

  connect() {
    console.log("connected to the checkbox controller!!")
    this.updateCheckAll()
  }

  toggleAll() {
    const checked = this.checkAllTarget.checked

    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  toggleItem() {
    this.updateCheckAll()
  }

  updateCheckAll() {
    const total = this.itemTargets.length
    const checked = this.itemTargets.filter(cb => cb.checked).length

    this.checkAllTarget.checked = (total === checked)
  }
}